// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9b58e969","703":"5b385bdf"}[chunkId] + ".chunk.js";
};